import * as React from 'react';
import type { SVGProps } from 'react';
const SvgZoomIn = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<circle cx={11} cy={11} r={7} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
		<line x1={20} y1={20} x2={16.5} y2={16.5} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
		<line x1={11} y1={8} x2={11} y2={14} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
		<line x1={8} y1={11} x2={14} y2={11} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
	</svg>
);
export default SvgZoomIn;
